import React from 'react';
import { helper } from '../utilities/helper';



const TopMenu = ({className, tabItems, tab, setTab, mini, fixed, children }) => {


    return <div data-msr-surface='dark' className={`topMenu  ${mini ? 'mini' :''} ${className}`} >
        {children}
        {tabItems?.map((tb, i) => {
            return <div key={i} className={`topMenu-button`} tab={tb} id={tab === tb ? 'sel' : ''} onClick={() => setTab(tb)}>
                {helper.shortText(tb,4)}
            </div>
        })}
    </div>
}

export default TopMenu
